import { AuthenticationType } from 'authentication/shared/types'
import { useTranslation } from 'react-i18n-lite'
import { useSelector } from 'react-redux'
import { useLocation, useSearchParams } from 'react-router-dom'
import { useFetchYesObjects } from 'yesObject/shared'

const useHomeSitemodels = (enabled = false) => {
  const token = useSelector(
    ({ authentication }: AuthenticationType) => authentication.token
  )

  const { language: languageInLocalStorage } = useTranslation()

  const [searchParams] = useSearchParams()
  const languageInUrl = searchParams.get('lang')

  const location = useLocation()
  const isRoot = location.pathname === '/'

  const {
    yesObjects: homeSitemodels,
    isLoading,
    fetchYesObjects: fetchHomeSitemodels,
    isFetched
  } = useFetchYesObjects({
    filteractionUuid: globalThis.defaultSitemodelFilteractionUuid,
    showLoading: true,
    initialSortOptions: [{ priority: 'desc' }],
    additionalQueryKeyParams: [token ?? ''],
    enabled: isRoot || enabled,
    interpolationObject: {
      UserLanguage: languageInUrl || languageInLocalStorage
    }
  })

  return {
    homeSitemodels,
    fetchHomeSitemodels,
    isLoading,
    isFetched
  }
}

export default useHomeSitemodels
